import api from './api';

const placePaymentsService = {
  getByPlace: (placeId) => api.get(`/places/${placeId}/payments`).then(r => r.data),
  create: (placeId, data) => api.post(`/places/${placeId}/payments`, data).then(r => r.data),
  setAll: (placeId, paymentIds, confirmCascade = false) =>
    api.put(`/places/${placeId}/payments`, { placeId, paymentIds, confirmCascade })
       .then(r => r.data),
  previewCascade: (placeId, paymentId) =>
    api.get(`/places/${placeId}/payments/${paymentId}/cascade-preview`).then(r => r.data),
  delete: (placeId, id, confirmCascade = false) =>
    api.delete(`/places/${placeId}/payments/${id}`, { params: { confirmCascade } }),
};

export default placePaymentsService;
